import React from 'react';
import { Grid } from 'antd';
import Overview from '../Overview/Overview';

const { useBreakpoint } = Grid;

const MarketAnalysis = ({ data, activeTab, marketScope, dealerState }) => {
  if (!data) return null;

  // Helper function to get listing state from various possible fields
  const getListingState = (listing) => {
    return listing.state || 
           listing.dealer_state || 
           listing.location?.state || 
           listing.dealer?.state ||
           listing.seller_state;
  };

  // Helper function to check if listing matches dealer state
  const matchesDealerState = (listing) => {
    if (!dealerState) return true;
    const listingState = getListingState(listing);
    return listingState && listingState.toUpperCase() === dealerState.toUpperCase();
  };

  // Filter data based on market scope
  let filteredData = data;
  
  if (marketScope === 'my-state' && dealerState) {
    // Filter active listings
    const filteredActiveListings = (data.market_analysis?.active_listings || []).filter(matchesDealerState);
    
    // Filter recent sales
    const filteredRecentSales = (data.market_analysis?.recent_sales || []).filter(matchesDealerState);
    
    // Recalculate market metrics from filtered data
    const calculateMarketMetrics = () => {
      if (!data.market_analysis?.market_metrics) return null;
      
      // Calculate average price from filtered sales
      const prices = filteredRecentSales
        .map(sale => sale.price || sale.sold_price)
        .filter(p => p && p > 0);
      const avgPrice = prices.length > 0 
        ? prices.reduce((sum, price) => sum + price, 0) / prices.length 
        : data.market_analysis.market_metrics?.market_avg_price || null;
      
      // Calculate average DOM from filtered sales
      const doms = filteredRecentSales
        .map(sale => sale.dom_active || sale.dom)
        .filter(d => d && d > 0);
      const avgDOM = doms.length > 0 
        ? doms.reduce((sum, dom) => sum + dom, 0) / doms.length 
        : data.market_analysis.market_metrics?.avg_days_on_market || null;
      
      return {
        ...data.market_analysis.market_metrics,
        active_count: filteredActiveListings.length,
        sold_count: filteredRecentSales.length,
        market_avg_price: avgPrice,
        avg_days_on_market: avgDOM,
      };
    };

    // Create a filtered copy of the data
    filteredData = {
      ...data,
      market_analysis: {
        ...data.market_analysis,
        active_listings: filteredActiveListings,
        recent_sales: filteredRecentSales,
        market_metrics: calculateMarketMetrics(),
      }
    };
  }

  // Use Overview component for both desktop and mobile
  return <Overview data={filteredData} activeTab={activeTab} />;
};

export default MarketAnalysis;
